import uniqid from 'uniqid';

import { type ConfigState } from '.';

const initialState: ConfigState = {
  apiKey: '',
  intentFiltersForPreview: null,
  lastActiveTabId: uniqid(),
  origin: '',
  previewIsLiveMode: null,
  rawParams: {},
  updatedAtMilliseconds: 0,
  widgetInitMethod: 'url',
};

export default initialState;
